<script setup>
</script>

<template>
    <div class="fixed inset-0 z-0 pointer-events-none bg-slate-900">
        <div
            class="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-indigo-600/30 rounded-full blur-[120px] mix-blend-screen animate-pulse-slow">
        </div>
        <div
            class="absolute top-[20%] right-[-10%] w-[40%] h-[60%] bg-purple-600/20 rounded-full blur-[100px] mix-blend-screen animate-pulse-slower">
        </div>
        <div
            class="absolute bottom-[-10%] left-[20%] w-[60%] h-[40%] bg-blue-600/20 rounded-full blur-[130px] mix-blend-screen animate-float">
        </div>
    </div>
</template>

<style scoped>
.animate-pulse-slow {
    animation: pulse 8s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.animate-pulse-slower {
    animation: pulse 12s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.animate-float {
    animation: float 20s ease-in-out infinite;
}

@keyframes float {
    0% {
        transform: translate(0, 0);
    }

    50% {
        transform: translate(20px, -20px);
    }

    100% {
        transform: translate(0, 0);
    }
}
</style>
